export default __webpack_public_path__ + "static/s-oliver-avatar-150x150-cba365f2d2a0e89c7960195a5d3308bd.png";